import React from 'react';
import { bool, func } from 'prop-types';
import { connect } from 'react-redux';
import SafePureComponent from '../shared/SafePureComponent';
import { isTriplePackage } from '../../reducers/packages';
import SinglePackage from './SinglePackage';
import TriplePackage from './TriplePackage';

import './style.scss';

const PackagesTabs = ({
    shouldRender = true,
    isTriplePackage,
    onComparePackagesClick
}) => {

    if (!shouldRender) {return null;}

    const Component = isTriplePackage ? TriplePackage : SinglePackage;

    return (
        <Component onComparePackagesClick={onComparePackagesClick}/>
    );
};

PackagesTabs.propTypes = {
    shouldRender: bool,
    isTriplePackage: bool,
    onComparePackagesClick: func
};

const mapStateToProps = ({ packages }) => ({
    shouldRender: packages.packageList.length > 0,
    isTriplePackage: isTriplePackage(packages)
});

export { PackagesTabs };
export default SafePureComponent(connect(mapStateToProps)(PackagesTabs));
